<template>
  <v-btn icon @click="shufflePlay()" :class="isShuffle? '--active': '--notActive'">
    <v-icon>shuffle</v-icon>
  </v-btn>
</template>
<script>
export default {
  name: 'PlayerShuffleBtn',
  methods: {
    shufflePlay () {
      let isRandom = !this.isShuffle
      this.$store.commit('musicPlayerModuleShuffle', isRandom)
    }
  },
  computed: {
    isShuffle () {
      return this.$store.getters.musicPlayerModuleGetIsShufflePlay
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PlayerShuffleBtn.vue